import { render, staticRenderFns } from "./PaymentPeriodicityType.vue?vue&type=template&id=669d5e67"
import script from "./PaymentPeriodicityType.vue?vue&type=script&lang=js"
export * from "./PaymentPeriodicityType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports